var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16.000000pt",
    height: "16.000000pt",
    viewBox: "0 0 16.000000 16.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,16.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 133 c-15 -6 -17 -39 -3 -48 20 -12 51 6 48 28 -3 22 -22 30 -45 20z m33 -14 c10 -17 -13 -36 -27 -22 -12 12 -4 33 11 33 5 0 12 -5 16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 50 c-11 -11 -20 -26 -19 -32 0 -7 5 -3 11 9 20 42 76 42 96 0 6 -12 11 -16 11 -9 1 19 -36 52 -59 52 -11 0 -29 -9 -40 -20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f3ed6711059c65244646b06ba58f79e3.svg";
export { ForwardRef as ReactComponent };